import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { BaseQuestionEditComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { SpeakingSettingsConfigComponent } from './speaking-settings-config.component';
import { TimeUnit, SpeakingMinAnswerDuration } from '@module/form';
import { jsx as _jsx } from "react/jsx-runtime";
export var SpeakingEditComponent = function SpeakingEditComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var speakingQuestion = question;
  var speakingSettings = states.speakingSettings || speakingQuestion.speakingSettings;
  var speakTimeSec = TimeUnit.toTotalSeconds(speakingSettings.speakingTime, speakingSettings.speakingTimeUnit);
  var isNoMinDuration = SpeakingMinAnswerDuration.isUnlimited(speakingSettings.minAnswerDuration);
  var minDurationSec = isNoMinDuration ? 0 : TimeUnit.toTotalSeconds(speakingSettings.minAnswerDuration, speakingSettings.minAnswerDurationUnit);
  var isMinDurationValid = isNoMinDuration || minDurationSec < speakTimeSec;

  var combinedStates = _objectSpread(_objectSpread({}, states), {}, {
    isValidForSave: states.isValidForSave !== false && isMinDurationValid
  });

  return /*#__PURE__*/_jsx(BaseQuestionEditComponent, {
    states: combinedStates,
    actions: actions,
    children: /*#__PURE__*/_jsx(SpeakingSettingsConfigComponent, {
      states: states,
      actions: actions
    })
  });
};